import { orchestrator } from 'satcheljs';
import { contactSupport } from '../actions/contactSupport';
import { hideFullOptions } from 'owa-options-core';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';

export default orchestrator(contactSupport, async function contactSupport() {
    hideFullOptions();
    logUsage(
        datapoints.PremiumDashContactPremiumSupport.datapoint.name,
        null,
        datapoints.PremiumDashContactPremiumSupport.datapoint.options
    );
});
